module.exports = __webpack_public_path__ + "static/img/gameonz-logo.ea824e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameonz/imgs/gameonz-logo.png
// module id = 1865
// module chunks = 0